'use client'

import { useEffect } from 'react'

// Last-resort boundary for errors thrown by the ROOT layout itself (before
// the providers mount). It replaces the entire document, so none of our
// providers, i18n, or globals.css are available here — everything must be
// self-contained and inline-styled. Keep it tiny and dependency-free.
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error('[global-error]', error.digest ?? '(no digest)', error)
  }, [error])

  // Best-effort theme + language so the fallback doesn't clash with the
  // user's Telegram surface. Guarded because this may run before the TG
  // script is ready.
  const bg = '#15121f'
  const text = '#f6f2ff'
  const hint = '#a79fbf'
  const button = '#c6f432'
  const buttonText = '#15121f'
  const code = typeof window !== 'undefined' ? window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code : undefined
  const isUk = !!code && code.toLowerCase().split('-')[0] === 'uk'

  const copy = isUk
    ? {
        title: 'Щось пішло не так',
        body: 'Застосунок не запустився. Спробуй перезавантажити.',
        cta: 'Перезавантажити',
      }
    : { title: 'Something went wrong', body: 'The app failed to start. Try reloading.', cta: 'Reload' }

  return (
    <html lang={isUk ? 'uk' : 'en'}>
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
          padding: '0 32px',
          textAlign: 'center',
          background: bg,
          color: text,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        }}
      >
        <div style={{ fontSize: 40 }} aria-hidden="true">
          😵‍💫
        </div>
        <div style={{ fontSize: 17, fontWeight: 600 }}>{copy.title}</div>
        <div style={{ fontSize: 13, color: hint, maxWidth: 320, lineHeight: 1.4 }}>{copy.body}</div>
        <button
          type="button"
          onClick={() => reset()}
          style={{
            marginTop: 16,
            height: 40,
            padding: '0 20px',
            borderRadius: 999,
            border: 'none',
            background: button,
            color: buttonText,
            fontSize: 15,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          {copy.cta}
        </button>
      </body>
    </html>
  )
}
